import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useSystemVersionStore = defineStore(
  'systemVersion',
  () => {
    const isNewSystem = ref<boolean>(true) // 預設新版（OP#1686 行為），僅在帳號被授權切換時生效
    const isNewApi = ref<boolean>(true) // 預設跟隨 isNewSystem，可於 Sidebar 獨立切換
    const isAllowedToSwitchSystem = ref<boolean>(false) // 帳號是否被授權切換新舊系統（由 fnGetUserInfo 依 webVersion 判斷）
    const isAllowedToSwitchApi = ref<boolean>(false) // 帳號是否被授權切換新舊 API（由 fnGetUserInfo 依 apiVersion 判斷）

    // 只在登入頁切換系統版本時同步，避免刷新頁面還原持久化狀態時被覆蓋
    const setIsNewSystem = (value: boolean) => {
      isNewSystem.value = value
      isNewApi.value = value
    }

    return {
      isNewSystem,
      isNewApi,
      isAllowedToSwitchSystem,
      isAllowedToSwitchApi,
      setIsNewSystem
    }
  },
  {
    persist: true
  }
)
